import { useContext } from 'react';
import { Theme } from '@cvent/carina/types/theme';
import ThemeContext from '@cvent/carina/components/ThemeProvider/ThemeContext';

interface ColorStack {
  seedColor: string;
  adjusted1: string;
  adjusted2: string;
  textOnSeed: string;
  stack: {
    '10': string;
    '15': string;
    '30': string;
    '45': string;
    '70': string;
    '100': string;
    '150': string;
    zero: string;
    max: string;
  };
}

export interface ThemeWithPalette extends Theme {
  palette?: {
    primary?: ColorStack;
    secondary?: ColorStack;
    additionalColor2?: ColorStack;
  };
  /** @deprecated Use palette.additionalColor2.seedColor */
  additionalColor2?: string;
}

/**
 * Simple hook for getting theme data from ThemeContext
 * https://carina-dev.core.cvent.org/components/breakpoints
 */

const useTheme = (): ThemeWithPalette => useContext(ThemeContext);

export default useTheme;
